<template>
  <TabsBtn
    :tabs="tabs"
    :activeTab="activeTab"
    @change="changeTab"
    :isShowBorder="true"
  />
  <div
    v-if="matches.length"
    class="as-h2h as-scrolling as-scrolling__result-popup as-mt-12"
  >
    <div class="as-match-list" :key="activeTab">
      <MatchItem
        v-for="(item, key) in matches"
        :key="key"
        :match="item"
        :teams="matchLiveData.teams"
        :competitions="matchLiveData.competitions"
        :commentators="matchLiveData.commentators"
        :isShowFlagHalf="true"
      />
      <div v-if="!isShowMore" @click="isShowMore = true" class="as-show-more">
        Hiển thị thêm trận đấu <ArrowDown />
      </div>
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { IMatch, IMatchLiveData } from "~src/interfaces";
import MatchItem from "~src/components/matches/MatchItem.vue";
import MatchEnum from "~src/enums/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";

interface IProps {
  matchLiveData: IMatchLiveData;
  matchId: string;
}

const props = withDefaults(defineProps<IProps>(), {});

const isShowMore = ref(props.matchLiveData.matches.length > 5 ? false : true);
const activeTab = ref("all");

const tabs = [
  {
    title: "Tất cả trận",
    key: "all",
  },
  {
    title: "Có bàn thắng",
    key: "goal",
  },
  {
    title: "Chưa bàn thắng",
    key: "no_goal",
  },
  {
    title: "H1",
    key: "h1",
  },
  {
    title: "H2",
    key: "h2",
  },
  {
    title: "Hiệp phụ",
    key: "hp",
  },
];

const matches = computed(() => {
  const _data = props.matchLiveData.matches.filter((match: IMatch) => {
    if (
      match.id === props.matchId ||
      match.status_id === MatchEnum.STATUS_END
    ) {
      return false;
    }

    if (activeTab.value === "all") {
      return true;
    }

    if (!MatchEnum.LIST_STATUS_PLAYING.includes(match.status_id)) {
      return false;
    }

    if (activeTab.value === "goal") {
      if (match.home_scores[0] != 0 || match.away_scores[0] != 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "no_goal") {
      if (match.home_scores[0] == 0 && match.away_scores[0] == 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h1") {
      if (match.status_id === MatchEnum.STATUS_FIRST_HALF) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h2") {
      if (match.status_id === MatchEnum.STATUS_SECOND_HALF) {
        return true;
      }

      return false;
    } else if (activeTab.value === "hp") {
      if (match.status_id === MatchEnum.STATUS_OVERTIME || match.status_id === MatchEnum.STATUS_OVERTIME_DEPRECATED) {
        return true;
      }

      return false;
    }

    return true;
  });

  if (isShowMore.value) {
    return _data;
  }
  return _data.slice(0, 5);
});

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const changeTab = async (tab: string) => {
  activeTab.value = tab;
};
</script>

<script lang="ts">
export default {};
</script>
